export class TransportIssue {

  id: number;

  issueTypeId: number;

  delay: number;

  text: string;

  deleted = false;
}
